<template>
  <div class="row justify-content-md-center" id="avaliation-form">
    <div class="col-12">
      <label class="form-control-label d-block mb-3">Título da Avaliação <span class="text-danger"> *</span></label>
      <base-input
        class="mb-3"
        v-model="formData.name"
        placeholder="Nome"
        :error="!formData.name && ((errors && errors.name && errors.name[0]) || (formData.name === '' ? 'O título da avaliação é obrigatório' : null))"
      />
    </div>
    <div class="col-12">
      <label class="form-control-label d-block mb-3">Descrição</label>
      <html-editor
        class="mb-3"
        v-model="formData.description"
        placeholder="Nome"
      />
    </div>
    <div class="col-12 mb-3">
      <label class="form-control-label d-block mb-3">Período PPR <span class="text-danger"> *</span></label>
      <multiselect
        v-model="participation_ppr"
        :options="participation_pprs || []"
        label="descricao"
        track-by="id"
        :allow-empty="true"
        :preserveSearch="true"
        :showNoResults="false"
        select-label=""
        deselect-label=""
        placeholder="Selecionar Período"
        :selected-label="'Selecionado'">
      </multiselect>
      <small class="form-text text-danger" v-if="!participation_ppr.id && errors.participation_ppr">{{ errors.participation_ppr[0] }}</small>
    </div>
    <div class="col-12 col-md-6 mb-3">
      <label class="form-control-label d-block mb-3">Perfil que será avaliado <span class="text-danger"> *</span></label>
      <multiselect
        v-model="avaliation_profile"
        :options="['Usuários', 'Papéis']"
        :allow-empty="true"
        :preserveSearch="true"
        :showNoResults="false"
        select-label=""
        deselect-label=""
        placeholder="Selecionar Perfil"
        :selected-label="'Selecionado'">
      </multiselect>
    </div>
    <div class="col-12 col-md-6 mb-3" v-if="avaliation_profile == 'Usuários'">
      <label class="form-control-label d-block mb-3">Usuários <span class="text-danger"> *</span></label>
      <multiselect
        v-model="user"
        :options="users || []"
        multiple
        label="name"
        track-by="id"
        :limit="1"
        :limit-text="(count) => ` + ${count}`"
        :close-on-select="false"
        :preserveSearch="true"
        :showNoResults="false"
        select-label=""
        deselect-label=""
        :loading="loading.users"
        @search-change="getUsers"
        placeholder="Selecionar Usuários"
        @input="clearValidation"
        :selected-label="'Selecionado'">
      </multiselect>
      <small class="form-text text-danger" v-if="isValid">Selecione pelo menos um usuário</small>
    </div>
    <div class="col-12 col-md-6 mb-3" v-else>
      <label class="form-control-label d-block mb-3">Papéis <span class="text-danger"> *</span></label>
      <multiselect
        v-model="role"
        :options="roles || []"
        multiple
        label="name"
        track-by="id"
        :limit="1"
        :limit-text="(count) => ` + ${count}`"
        :close-on-select="false"
        :preserveSearch="true"
        :showNoResults="false"
        select-label=""
        deselect-label=""
        placeholder="Selecionar Papéis"
        @input="clearValidation"
        :selected-label="'Selecionado'">
      </multiselect>
      <small class="form-text text-danger" v-if="isValid">Selecione pelo menos um papel</small>
    </div>

    <div class="col-12">
      <label class="form-control-label d-block mb-3">Perguntas <span class="text-danger"> *</span></label>
      <small class="form-text text-danger" v-if="errors.avaliation_items && (!formData.avaliation_items || formData.avaliation_items.length == 0)">
        A avaliação deve conter pelo menos uma pergunta
      </small>
      <br><br>

      <!-- Order Items -->
      <collapse class="mt--5">
        <collapse-item
          v-for="(item, index) in formData.avaliation_items || []"
          :key="item.index"
          :title="item.name || 'Nova Pergunta'"
          wrapperClasses=""
        >
          <!-- Actions -->
          <template v-slot:actions>
            <div>
              <base-button icon type="warning" v-on:click="removeAvaliationItem(index)" size="sm">
                <span class="btn-inner--icon">
                  <i class="fa fa-trash"></i>
                </span>
                <span class="btn-inner--text">Remover</span>
              </base-button>
              <i
                v-show="errors && errors.avaliation_items && errors.avaliation_items[0][index]"
                class="ml-3 text-warning fa fa-exclamation-triangle"
              >
              </i>
            </div>
          </template>

          <!-- Content -->
          <avaliation-item-form
            :value="item"
            :errors="(errors && errors.avaliation_items && errors.avaliation_items[0] && errors.avaliation_items[0][index]) || {}"
            @input="editAvaliationItem($event, index)"
          />
        </collapse-item>
      </collapse>

      <base-button
        size="sm"
        class="rounded-lg mx-auto my-4 d-block mb-3"
        type="primary"
        @click="addAvaliationItem"
      >
        Adicionar Pergunta
        <i class="fa fa-plus"></i>
      </base-button>
    </div>
  </div>
</template>

<script>
import HtmlEditor from '../Inputs/HtmlEditor.vue';
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import AvaliationItemForm from "./AvaliationItem/AvaliationItemForm.vue";

export default {
  name: 'AvaliationForm',
  components: {
    HtmlEditor,
    Multiselect,
    Collapse,
    CollapseItem,
    AvaliationItemForm,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    loading: {
      participation_pprs: false,
      users: false,
      roles: false,
    },
    avaliation_profile: 'Papéis',
    participation_pprs: [],
    users: [],
    roles: [],
    isValid: false
  }),
  mounted() {
    this.getParticipationPprs();
    this.getUsers();
    this.getRoles();
  },
  methods: {
    emitInput() {
      this.$emit('input', this.formData);
    },
    addAvaliationItem() {
      this.formData.avaliation_items = this.formData.avaliation_items || [];
      this.formData.avaliation_items.push({});
      this.formData = Object.assign({}, this.formData);
    },
    removeAvaliationItem(index) {
      this.formData.avaliation_items.splice(index, 1);
      this.formData = Object.assign({}, this.formData);

      if (this.errors && this.errors.avaliation_items && this.errors.avaliation_items.length) {
        this.errors.avaliation_items[0].splice(index, 1);
        this.$emit('update:errors', this.errors);
      }
    },
    editAvaliationItem(item, index) {
      this.formData.avaliation_items[index] = item;
      this.formData = Object.assign({}, this.formData);
    },
    async getParticipationPprs() {
      this.loading.participation_pprs = true;
      try {
        const { data } = await this.$http.secured.get('/api/v1/admin/participation_pprs', { params: { per_page: 100 } });
        this.participation_pprs = data.participation_pprs || [];
      } catch (error) {
        console.error("[AvaliationForm][getParticipationPprs] Error: ", error)
      }
      this.loading.participation_pprs = false;
    },
    async getRoles() {
      this.loading.roles = true;
      try {
        const { data } = await this.$http.secured.get('/api/v1/roles', { params: { per_page: 100 } });
        this.roles = data.roles || [];
      } catch (error) {
        console.error("[AvaliationForm][getRoles] Error: ", error)
      }
      this.loading.roles = false;
    },
    async getUsers(query = null) {
      this.loading.users = true;
      try {
        const { data } = await this.$http.secured.get('/api/v1/users', {
          params: {
            per_page: 10,
            q: { name: query }
          }
        });
        this.users = data.users || [];
      } catch (error) {
        console.error("[AvaliationForm][getUsers] Error: ", error)
      }
      this.loading.users = false;
    },
    validateFields() {
      this.isValid = this.avaliation_profile === 'Usuários'
        ? (!this.user || this.user.length === 0)
        : (!this.role || this.role.length === 0);
      return !this.isValid;
    },
  },
  computed: {
    formData: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    participation_ppr: {
      get() {
        return this.participation_pprs.find(ppr => ppr.id === this.formData.participation_ppr_id) || {};
      },
      set(value) {
        this.formData = Object.assign({}, this.formData, { participation_ppr_id: value.id })
      },
    },
    user: {
      get() {
        if (!(this.formData.user_ids && this.formData.user_ids.length > 0)) {
          return [];
        }

        return this.users.filter(user => this.formData.user_ids.includes(user.id));
      },
      set(value) {
        const userIds = value.map(user => user.id).filter(u => u)
        this.formData = Object.assign({}, this.formData, { user_ids: userIds })
      },
    },
    role: {
      get() {
        if (!(this.formData.role_ids && this.formData.role_ids.length > 0)) {
          return [];
        }

        return this.roles.filter(role => this.formData.role_ids.includes(role.id));
      },
      set(value) {
        const roleIds = value.map(role => role.id).filter(r => r)
        this.formData = Object.assign({}, this.formData, { role_ids: roleIds })
      },
    },
  },
  watch: {
    'role'() {
      if (this.avaliation_profile === 'Papéis' && this.role.length > 0) {
        this.isValid = false; 
      }
    },
    'user'() {
      if ((this.avaliation_profile === 'Usuários' && (!this.user || this.user.length > 0))) {
        this.isValid = false; 
      }
    },
    avaliation_profile(value) {
      console.log("[AvaliationForm][watch][avaliation_profile] value: ", value)
      if (value === 'Usuários') {
        this.formData = Object.assign({}, this.formData, { role_ids: [] })
      } else {
        this.formData = Object.assign({}, this.formData, { user_ids: [] })
      }
    },
    'formData.id'() {
      this.$nextTick(() => {
        this.avaliation_profile = this.formData.user_ids && this.formData.user_ids.length > 0 ? 'Usuários' : 'Papéis';
      });
    },
  },
}
</script>

<style>
#avaliation-form .collapse-item-title {
  text-transform: uppercase;
}
</style>
